import { Link } from 'react-router-dom';
import { useTheme } from '../../../hooks/useTheme';

const WHATSAPP = 'https://wa.me/18495388899?text=Hola%20InnoFlex!%20Me%20gustar%C3%ADa%20una%20demo%20gratis.';

export default function IndustriesCTA() {
  const { theme } = useTheme();
  const isLight = theme === 'light';

  return (
    <section
      className="py-20 px-4 sm:px-6"
      style={{
        background: isLight
          ? 'linear-gradient(135deg, #f0f9ff 0%, #f0fdf4 100%)'
          : 'linear-gradient(135deg, #060c1c 0%, #0a1628 100%)',
        borderTop: isLight ? '1px solid rgba(10,22,40,0.08)' : '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <div className="max-w-4xl mx-auto text-center">
        {/* Icon */}
        <div
          className="w-16 h-16 flex items-center justify-center rounded-2xl mx-auto mb-6"
          style={{ background: 'linear-gradient(135deg, #00cfff20 0%, #10b98120 100%)', border: '1px solid #00cfff30' }}
        >
          <i className="ri-rocket-line text-2xl text-electric" />
        </div>

        <h2
          className="font-heading text-3xl sm:text-4xl font-extrabold mb-4 leading-tight"
          style={{ color: isLight ? '#0a1628' : '#ffffff' }}
        >
          ¿Listo para automatizar{' '}
          <span className="text-electric">tu negocio</span>?
        </h2>
        <p
          className="font-body text-base sm:text-lg leading-relaxed max-w-xl mx-auto mb-10"
          style={{ color: isLight ? 'rgba(10,22,40,0.60)' : 'rgba(255,255,255,0.55)' }}
        >
          Sin importar tu industria, InnoFlex se activa desde 48h. Sistema POS, ERP, contabilidad y facturación e-CF certificada DGII desde un solo lugar.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            to="/#book-demo"
            className="flex items-center gap-2.5 px-8 py-3.5 rounded-full font-body text-sm font-extrabold transition-all duration-200 hover:scale-105 active:scale-95 whitespace-nowrap cursor-pointer"
            style={{
              background: 'linear-gradient(135deg, #00cfff 0%, #10b981 100%)',
              color: '#0a1628',
              boxShadow: '0 0 28px rgba(0,207,255,0.30)',
            }}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-schedule-line text-sm" />
            </div>
            Agenda tu Demo Gratis
          </Link>

          <a
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-2.5 px-7 py-3.5 rounded-full font-body text-sm font-semibold transition-all duration-200 hover:scale-105 cursor-pointer whitespace-nowrap"
            style={{
              backgroundColor: isLight ? 'rgba(37,211,102,0.10)' : 'rgba(37,211,102,0.12)',
              border: '1px solid rgba(37,211,102,0.30)',
              color: '#25D366',
            }}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-sm" />
            </div>
            Hablar por WhatsApp
          </a>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
          {[
            { icon: 'ri-shield-check-line', label: 'DGII Certificado' },
            { icon: 'ri-timer-line', label: 'Activo desde 48h' },
            { icon: 'ri-customer-service-2-line', label: 'Soporte 24/7' },
            { icon: 'ri-map-pin-2-line', label: 'Santo Domingo, RD' },
          ].map((badge) => (
            <div
              key={badge.label}
              className="flex items-center gap-1.5 font-body text-xs font-semibold"
              style={{ color: isLight ? 'rgba(10,22,40,0.45)' : 'rgba(255,255,255,0.40)' }}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${badge.icon} text-xs text-electric`} />
              </div>
              {badge.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
